module.exports = __webpack_public_path__ + "static/futur-call-hero-es-eb64244ee16122cd60f7bbefcc3d682b.jpg";